var _this = this;

import React, { memo } from 'react';
import { Grid } from '@material-ui/core';
import Icon from '../../../../core/Icon/Icon';
import Form from '../../../../form';
var selectProps = {
  label: null,
  variant: 'filled',
  multi: false,
  menuPlacement: 'auto'
};
var errorStyles = {
  color: '#f44336',
  marginTop: '-8px',
  padding: '0 14px 0 14px',
  fontSize: '0.75rem',
  lineHeight: '1.66',
  borderTop: '1.5px solid #f44336',
  width: '100%'
};
var clickedIndex = -1; // shared between mappings

var FieldMapping = function FieldMapping(props) {
  var name = props.name,
      index = props.index,
      mappingOptions = props.mappingOptions,
      onRemove = props.onRemove,
      errors = props.errors;
  var onMenuOpen = React.useCallback(function () {
    clickedIndex = index;
  }, []);
  var onMenuClose = React.useCallback(function () {
    if (index === clickedIndex) return true;
    return false;
  }, []);
  return React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, React.createElement(Form.Fields.MultiSelect, Object.assign({
    name: name + '.Source.Name',
    id: name + '.Source.Name',
    options: mappingOptions.sources,
    onMenuOpen: onMenuOpen,
    closeMenuOnScroll: onMenuClose
  }, selectProps)), errors && errors.Source && React.createElement("p", {
    style: errorStyles,
    id: "error-source-mapping-".concat(index)
  }, errors.Source)), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1
  }), React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, React.createElement(Form.Fields.MultiSelect, Object.assign({
    name: name + '.Destination.Name',
    id: name + '.Destination.Name',
    options: mappingOptions.destinations,
    onMenuOpen: onMenuOpen,
    closeMenuOnScroll: onMenuClose
  }, selectProps)), errors && errors.Destination && React.createElement("p", {
    style: errorStyles,
    id: "error-destination-mapping-".concat(index)
  }, errors.Destination)), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end'
    }
  }, React.createElement(Icon, {
    type: "remove",
    onClick: onRemove.bind(_this, index),
    style: {
      paddingLeft: '6rem'
    }
  })));
};

export default memo(FieldMapping);